(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugp-brand-values"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('.ugp-values');
  if (!section) return;
  section.querySelectorAll('.ugp-values__tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      section.querySelectorAll('.ugp-values__tab').forEach(function (t) {
        t.classList.remove('ugp-values__tab--active');
        t.setAttribute('aria-selected', 'false');
      });
      section.querySelectorAll('.ugp-values__panel').forEach(function (p) {
        p.hidden = true;
        p.classList.remove('ugp-values__panel--active');
      });
      tab.classList.add('ugp-values__tab--active');
      tab.setAttribute('aria-selected', 'true');
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) { panel.hidden = false; panel.classList.add('ugp-values__panel--active'); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugp-collection-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ugp-slider').forEach(function (section) {
    var trackEl = section.querySelector('.ugp-slider__track');
    if (!trackEl) return;
    var sectionId = trackEl.id.replace('ugp-track-', '');
    var dotsWrap  = section.querySelector('#ugp-dots-' + sectionId);
    var btnPrev   = section.querySelector('[data-ugp-prev]');
    var btnNext   = section.querySelector('[data-ugp-next]');
    var items     = Array.from(trackEl.querySelectorAll('.ugp-slider__item'));
    var current   = 0;

    function itemW() { return (items[0] ? items[0].offsetWidth : 0) + 20; }

    if (dotsWrap) {
      items.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'ugp-slider__dot' + (i === 0 ? ' ugp-slider__dot--active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(dot);
      });
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, items.length - 1));
      trackEl.scrollTo({ left: current * itemW(), behavior: 'smooth' });
      updateUI();
    }

    function updateUI() {
      if (btnPrev) btnPrev.disabled = current === 0;
      if (btnNext) btnNext.disabled = current >= items.length - 1;
      if (dotsWrap) {
        dotsWrap.querySelectorAll('.ugp-slider__dot').forEach(function (d, i) {
          d.classList.toggle('ugp-slider__dot--active', i === current);
        });
      }
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); });

    var scrollTimer;
    trackEl.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        current = Math.round(trackEl.scrollLeft / itemW());
        updateUI();
      }, 80);
    }, { passive: true });

    updateUI();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
